var _circle, _circle2, _circle3, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotMenuHorizontalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      cursor: "pointer"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 11.3862,
    r: 1.5,
    transform: "rotate(-180 17.5 11.3862)",
    fill: "#04B7EF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.3862,
    r: 1.5,
    transform: "rotate(-180 11.5 11.3862)",
    fill: "#04B7EF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 11.3862,
    r: 1.5,
    transform: "rotate(-180 5.5 11.3862)",
    fill: "#04B7EF"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        circle {\n        transition: fill 0.5s ease;\n        }\n        svg:hover circle {\n        fill: #04A5D8;\n        }\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotMenuHorizontalIcon);
export default __webpack_public_path__ + "static/media/DotMenuHorizontalIcon.52df027e1493ced40005289f20871be9.svg";
export { ForwardRef as ReactComponent };